module.exports = __webpack_public_path__ + "static/media/DS_Membership_Pic1.3e661d0c.webp";